module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-breadcrumbs",
    class: ( _obj = {}, _obj[("bg_" + _vm.bg)] = true, _obj )
  }, [_c('markup-wrapper', [_c('bread-crumbs', {
    key: _vm.$route.fullPath,
    staticClass: "bread-crumbs",
    attrs: {
      "items": _vm.list
    }
  })], 1), _vm._t("before"), _c(_vm.wide ? "div" : "markup-wrapper", {
    tag: "div",
    staticClass: "flex"
  }, [_vm._t("default")], 2), _vm._t("after")], 2)
  var _obj;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7699bf6d","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Breadcrumbs.vue
// module id = 89f5ab41e38644b870ed
// module chunks = 0